// components/Modals/EditThreadForm.jsx
import React, { useState, useEffect } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import api from '../../functions/api';
import { useToast } from '../ToastProvider';
import { ReactComponent as IconClose } from "../../assets/icons/icon-close.svg";

const EditThreadForm = ({ data, show, handleClose, onUpdated }) => {
  const initialForm = {
    id_thread: '',
    nombre: '',
    uui: ''
  };

  /* ---------- formData ---------- */
  const [formData, setFormData] = useState(initialForm);
  const resetForm = () => setFormData(initialForm);

  const { showError } = useToast();

  useEffect(() => {
    if (data) {
      setFormData({ ...data });
    }
  }, [data]);

  const handleChange = (e) => {
    setFormData(prev => ({ ...prev, nombre: e.target.value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('access_token');
      const idUser = localStorage.getItem('id_user');
      const response = await api.put(
        `/langgraph/threads/${idUser}`,
        { uuid: data.uuid, name: formData.nombre },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      onUpdated?.(response.data);
      handleClose();
    } catch (error) {
      showError('Error al actualizar la conversación');
    }
  };

  return (
    <Modal show={show} onHide={handleClose} onExited={resetForm} backdrop="static" centered dialogClassName="basic-modal">
      <Modal.Header closeButton={false}>
        <Modal.Title>Editar Conversación</Modal.Title>
        <button
          type="button"
          onClick={handleClose}
          aria-label="Cerrar modal"
          className="btn-reset ms-auto"   // define estilo a tu gusto
        >
          <IconClose className="mc-link__icon secondary" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Nuevo nombre</Form.Label>
            <Form.Control
              type="text"
              nombre="nombre"
              value={formData.nombre}
              onChange={handleChange}
              required
            />
          </Form.Group>
          <div className="d-grid">
            <Button variant="primary" type="submit" className="btn-dark">Guardar</Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EditThreadForm;
